<template>
    <div class="wrapper">

      <template v-for="(count, index) in inputCount">
        <div class="row-wrapper" :key="index">
          <button type="button"
                  class="button delete-btn is-danger"
                  @click="deleteContact(index)"
                  v-if="canDelete"
                  :disabled="count === inputCount"
          >
            <font-awesome-icon icon="trash-alt" />
          </button>
          <contact-form :contact-type="$attrs['contact-type']"
                        :disabled="$attrs['disabled']"
                        :remove-key-on-update="$attrs['remove-key-on-update']"
                        class="contact-form"
                        v-model="contacts[index]"/>
        </div>
      </template>

    </div>
</template>

<script>
import { isEmpty, isEqual } from 'lodash-es'

import ContactForm from '@/components/FormContact'
export default {
  name: 'ContactFormMultiple',

  props: {
    canDelete: {
      type: Boolean,
      default: false
    },

    value: {
      type: Array,
      validator(list) {
        return list.every(
          (item) => item.hasOwnProperty('name') && item.hasOwnProperty('phone') && item.hasOwnProperty('email')
        )
      },
      default: () => []
    }
  },

  created() {
    // make a local copy of the prop data that was passed in so that when we change it... we change the local data.
    // any changes to this data will be sent back to the parent via an event
    this.contacts = [...this.contacts, ...this.value]
  },

  data() {
    return {
      contacts: []
    }
  },

  methods: {
    deleteContact(index) {
      const removedContacts = this.contacts.splice(index, 1)
      this.$emit('deleted', removedContacts[0])
    }
  },

  components: {
    ContactForm
  },

  computed: {
    inputCount() {
      // count the number of non-empty contacts that are in the array
      return this.contacts.filter((contact) => contact.name).length + 1
    }
  },

  watch: {
    value: {
      deep: true,
      handler() {
        if (!isEqual(this.value, this.contacts)) {
          this.contacts = isEmpty(this.value) ? [] : this.value
        }
      }
    },

    contacts(oldList, newList) {
      // if the old and new lists are empty... then do nothing because nothing really changed
      if (oldList.length || newList.length) {
        // filter out contacts with empty values
        const validContacts = this.contacts.filter((contact) => Object.values(contact).filter((v) => v).length)
        this.$emit('input', validContacts)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  padding: 8px;
}

.row-wrapper {
  display: flex;
  width: 100%;
  align-items: center;

  .delete-btn {
    margin-top: 15px;
    margin-right: 3px;
  }

  .contact-form {
    flex: 1;
  }
}

.invite-list {
  overflow: auto;
}

.notify-col {
  display: flex;
  align-items: center;
}
</style>
